module.exports = __webpack_public_path__ + "img/empty-img.fc72fd2a.png";